
import React from 'react';
import { Sun, Moon, Laptop } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();

  const themeOptions = [
    { name: 'light', icon: Sun, label: 'Light mode' },
    { name: 'dark', icon: Moon, label: 'Dark mode' },
    { name: 'system', icon: Laptop, label: 'System mode' },
  ];

  return (
    <div className="flex items-center py-1 px-2 rounded-full bg-slate-200 dark:bg-slate-700 border border-slate-300 dark:border-slate-600">
      {themeOptions.map((option) => {
        const Icon = option.icon;
        return (
          <button
            key={option.name}
            onClick={() => setTheme(option.name)}
            className={`p-1.5 rounded-full transition-colors ${
              theme === option.name
                ? 'bg-white dark:bg-slate-900 text-blue-600 dark:text-blue-400 shadow-sm'
                : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'
            }`}
            aria-label={option.label}
            title={option.label}
          >
            <Icon className="w-4 h-4" />
          </button>
        );
      })}
    </div>
  );
}
